import React from 'react'
import EditCarrierForm from './forms/EditCarrierForm'
import { Anchor } from './common/Anchor'
import FormHeader from './common/FormHeader'
import { createCarrierAction } from '../actions/carriersActions'

const CreateCarrier = () => {
  const crumbs = [
    <Anchor to="/inventory/all">Inventory</Anchor>,
    <Anchor to="/inventory/all/carriers">Carriers</Anchor>,
    'Create Carrier',
  ]

  return (
    <section className="CreateCarrier">
      <FormHeader crumbs={crumbs} />
      <EditCarrierForm submitAction={createCarrierAction} />
    </section>
  )
}

export default CreateCarrier
